export default "__VITE_ASSET__AhiMBbub__"